// extracted by mini-css-extract-plugin
export default {"row":"tableSortedBody_row__Z9H64","td":"tableSortedBody_td__HS4RW","cell":"tableSortedBody_cell__eBkWA"};